




































import { defineComponent, ref, onMounted, PropType } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import TopHorizontalItems from '~/components/pages/Top/TopHorizontalItems.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { SHOP_ANCHOR, ARTICLE_ID_PREFIX, BLOG_DISPLAY_COUNT } from '~/constants';
import { THUMBNAIL_250 } from '~/constants/profilesForImage';
import { url, extractText } from '~/utils';
import { BlogArticle } from '~/types/modules/blog';

export default defineComponent({
  components: {
    AppImage,
    TopHorizontalItems,
    AppRectButton,
  },
  props: {
    shopPermalink: {
      type: String,
      required: true,
    },
    articles: {
      type: Array as PropType<BlogArticle[]>,
      required: true,
    },
    hasNoArticles: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const fallbackImage = require('~/assets/images/content-ogp-fallback.png');
    const hasMounted = ref(false);
    const isInvalidImagePath = ref(false);
    onMounted(() => (hasMounted.value = true));

    // IDに'blog_'が入っている場合は、IDを取り除く
    const parseArticleId = (id: string) => {
      if (!id) return id;
      return id.includes(ARTICLE_ID_PREFIX) ? id.slice(ARTICLE_ID_PREFIX.length) : id;
    };

    const imageLoadError = () => {
      isInvalidImagePath.value = true;
    };

    return {
      dayjs,
      url,
      extractText,
      SHOP_ANCHOR,
      BLOG_DISPLAY_COUNT,
      hasMounted,
      fallbackImage,
      isInvalidImagePath,
      parseArticleId,
      imageLoadError,
      THUMBNAIL_250,
    };
  },
});
